import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import RootEntry from "../pages/RootEntry";
import ParkingAdminPage from "../pages/parking-admin/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <RootEntry />,
  },
  {
    path: "/kanri",
    element: <ParkingAdminPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
